
define(['jquery', 'core/ajax', 'core/notification', 'core/templates', 'core/modal_factory', 'select2-js', 'core/modal_events','core/url','datatables.net',
'datatables.net',
'datatables.net-bs4',
'datatables.net-buttons',
'datatables.net-buttons-bs4',
'datatables.net-buttons-colvis',
'datatables.net-buttons-print',
'datatables.net-buttons-html',
'datatables.net-buttons-flash',
'datatables.net-responsive',
'datatables.net-responsive-bs4'], function ($, ajax, notification, Templates, ModalFactory, select2, ModalEvents, moodleurl) {
return {
    init: function () {
      $('#mycoursetransaction').DataTable();    
    }
};
});

